import { h } from 'preact';
import { useState } from 'preact/hooks';
import { SectionDivider } from '../SectionDivider';
import { T } from '../../../styles/tokens';
import type { ComponentShowcase } from '../registry';

function SectionDividerDemo() {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(true);

  const icon = (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={T.textSecondary} strokeWidth="2">
      <circle cx="12" cy="12" r="10"/>
    </svg>
  );

  return (
    <div style={{ background: T.bgInput, padding: 16, borderRadius: 12 }}>
      <SectionDivider title="Seção Fechada" open={open} onToggle={() => setOpen(!open)} icon={icon} badge="Resumo aqui">
        <div style={{ padding: '8px 0', color: T.text, fontSize: 13 }}>Conteúdo colapsável da seção.</div>
      </SectionDivider>
      <SectionDivider title="Seção Aberta" open={open2} onToggle={() => setOpen2(!open2)} icon={icon} badge="Badge">
        <div style={{ padding: '8px 0', color: T.text, fontSize: 13 }}>Este conteúdo está visível.</div>
      </SectionDivider>
    </div>
  );
}

export const showcase: ComponentShowcase = {
  name: 'SectionDivider',
  category: '📋 Cards & Layout',
  description: 'Botão-accordion com chevron e badge para seções colapsáveis',
  usedIn: ['AgentesPage (modal Criar Agente)'],
  example: SectionDividerDemo,
};
